import Cookies from 'js-cookie';

const Storage = {
    cookies: {
        set(key, val, attributes) {
            const value = JSON.stringify(val);
            Cookies.set(key, value, attributes);
        },
        get(key) {
            const value = Cookies.get(key);
            try {
                return JSON.parse(value);
            } catch (err) {
                return value;
            }
        },
        remove(key, attributes) {
            Cookies.remove(key, attributes);
        },
    },
};

export default Storage;
